import { LandingPage } from '@composite';
import { Layout, StaticSEO } from '@core';
import React from 'react';

const NotFoundPage = () => {
  // const ref = React.useRef(null);
  // const locale = useLocale();
  return (
    <Layout invertedHeader>
      <StaticSEO pageId='404' />
      <LandingPage />
      {/* <CompactSectionStyles>
        <CompactSectionContent titleAs='h1' id='404.init' buttonLink={`/${locale}`}>
          <FinniRevealCards image='cards.jpg' triggerRef={() => ref} />
        </CompactSectionContent>
      </CompactSectionStyles>
      <Box sx={{ height: 0, margin: 0, padding: 0 }}>
        <Box ref={ref} />
      </Box> */}
    </Layout>
  );
};

export default NotFoundPage;
